export default "__VITE_ASSET__B5HZI1AW__"